import "./tiered-select.less";
import template from "./tiered-select.html";
import {
	filter,
	find
} from "lodash";
import {
	EVENT_FILTER_PRIMARYDATE,
	EVENT_REQUEST_REPORTING_ENTITY
} from "constants.js";

export class Controller {
	constructor(uiHelpers, $uibModal, $scope, eventBus, toastr, loadingService, featureCallbacks, entityManager, $logger, appState) {
		this.uiHelpers = uiHelpers;
		this._uibModal = $uibModal;
		this._scope = $scope;
		this._toastr = toastr;
		this.loadingService = loadingService;
		this.featureCallbacks = featureCallbacks;
		this.entityManager = entityManager;
		this.logger = $logger;
		this.appState = appState;
		this.globalEvents = eventBus;
	}

	$onInit() {
		this._eventBus = this.reportScope?.events ?? this.globalEvents;
		const ctrl = this;

		this.blur = this.onBlur;

		ctrl.friendly = ctrl.friendly || {};
		ctrl.primary = ctrl.primary || {};

		if(this.reportScope && (this.isTiered || this.hasEffectiveRanges)) {
			this._eventBus.register(EVENT_FILTER_PRIMARYDATE, (e, params) => {
				this.effectiveAsOf = params.effectiveAsOf;

				this._scope.$apply();

				if(this.box) {
					this.setChoices();
				}
			}, this._scope);
		}
	}

	setBox(box) {
		const ctrl = this;

		ctrl.box = box;
		ctrl.setChoices();

		ctrl.configureSelectbox();

		if(ctrl.friendly.Id) {
			ctrl.setChoice(ctrl.friendly.Id);
		}
	}

	configureSelectbox() {
		const ctrl = this;

		const selectBox = {
			setChoices: function(data) {
				ctrl.setChoices(data);
			},
			setValue: function(primary, friendly, setChoice) {
				if(setChoice === undefined)
					setChoice = true;

				ctrl.primary = primary;
				ctrl.friendly = friendly;
				const id = friendly ? friendly.Id : primary.Id;
				ctrl.value = id;

				if(setChoice) {
					ctrl.setChoice(id);
				}
			},
			restore: (data) => {
				this.box.clearStore();
				this.setChoices(data);
			},
			clearSelected: () => ctrl.clearSelected(),
			reset: () => ctrl.reset(),
			enable: () => this.box.enable(),
			disable: () => this.box.disable(),
			refresh: () => this.handleChange(),
			checkForPrimary: () => this.checkForPrimary(),
			setDisplay: (id) => this.setDisplay(id),
			switchPrimary: () => this.checkForPrimary(true)
		};

		this.callbacks({
			selectBox
		});
	}

	setChoices(data) {
		if(data) {
			this.options = data;
		}
		const selectionChoices = this.uiHelpers.setDisplay(
			this.options,
			{
				recentlyUsedEnabled: this.groupRecents,
				hideCode: this.hideCode,
				searchCode: this.searchCode
			},
			this.renderingOptions?.Display?.List
		);

		this.box.setChoices(selectionChoices, "value", "label", true);
	}

	setChoice(id) {
		this.box.setValueByChoice(id && id.toString());
	}

	handleChange() {
		if(!this.value) {
			this.reset();
		} else {
			this.checkForPrimary();
		}
	}

	checkForPrimary(switchPrimary = false) {
		const isEntitySelf = this.entityQueryConfiguration !== undefined
			? this.entityQueryConfiguration?.RelationshipType?.Code === "SELF"
			: this.entityManager.isEntitySelf(this.friendly);
		if(!isEntitySelf && this.friendly.Id && (!this.primary.Id || switchPrimary)) {
			const validEntities = filter(this.friendly.Entities, (e) => (e.Entity && (e.Entity.valid === undefined || e.Entity.valid)));
			const graceEntities = filter(this.friendly.Entities, (e) => (e.Entity && (e.Entity.inGrace === undefined || e.Entity.inGrace)));

			if(validEntities.length === 0) {
				if(graceEntities.length === 0) {
					this._toastr.error(`${this.friendly.Name || this.friendly.Code} does not have a valid license for the selected date.`);
					this.setPrimary();
					return;
				}
				else if(graceEntities.length === 1) {
					this.primary = graceEntities[0].Entity;
					this.setPrimary();
					return;
				}
				else {
					this.shouldRequestPrimaryUpdate ? this.requestReportingEntity() : this.activateModal(this.friendly);
					return;
				}
			}
			else if(validEntities.length === 1) {
				this.primary = validEntities[0].Entity;
				this.setPrimary();
				return;
			}
			else {
				this.shouldRequestPrimaryUpdate ? this.requestReportingEntity() : this.activateModal(this.friendly);
				return;
			}
		}

		this.triggerParentChange();
	}

	requestReportingEntity() {
		this.globalEvents.trigger(EVENT_REQUEST_REPORTING_ENTITY, {
			friendly: this.friendly
		});
	}

	triggerParentChange() {
		const selection = this.single ? {
			primary: this.primary,
			friendly: this.friendly
		} :
			this.box.getValue(true);

		this.onSelect({
			selection
		});
	}

	setPrimary() {
		this.clearSelected();
		if(this.primary.Id) {
			this.setChoice(this.friendly.Id || this.primary.Id);
		} else {
			this.friendly = {};
			this.value = {};
		}
		this.triggerParentChange();
	}

	reset() {
		this.primary = {};
		this.friendly = {};
		this.value = {};
		this.onSelect({});
	}

	clearSelected() {
		const values = this.box.getValue(true);
		this.box.removeItemsByValue(values);
	}

	setDisplay(id) {
		id = parseInt(id);

		if((this.friendly || {}).Id != id || !(this.primary || {}).Id) {
			const item = find(this.options, {
				Id: id
			});

			this.primary = {};
			this.friendly = item;
			this.featureCallbacks.nestedEntityDateFilter(this.friendly, this.effectiveAsOf, this.appState.forms.selected.Seasons);
		}

		const selectedItemDirectives = {
			"hidden-print": this.renderingOptions?.Display?.Selected,
			"not-printing-hidden": this.renderingOptions?.Print ?? this.renderingOptions?.Display?.Selected
		};

		return this.uiHelpers.getEntityDisplay(this.friendly, this.primary, this.hideCode, this.hidePrimary, selectedItemDirectives);
	}

	activateModal() {
		this._uibModal
			.open({
				component: "primarySelector",
				size: "lg",
				resolve: {
					entity: () => this.friendly,
					asOfRange: () => this.effectiveAsOf
				}
			})
			.result
			.then(selection => {
				this.primary = selection;
			}).finally(() => {
				try {
					this.setPrimary();
					this.box.containerOuter.focus();
				}
				catch(err) {
					this.logger.warn("err", err);
				}
			});
	}
}

export default angular
	.module("vesl.components.tiered-select", [])
	.component("tieredSelect", {
		template: template,
		controller: Controller,
		bindings: {
			id: "@",
			label: "<",
			groupRecents: "<",
			single: "<",
			search: "<",
			options: "<",
			onSelect: "&",
			callbacks: "&",
			isTiered: "<",
			isReadonly: "<",
			suppressClear: "<?",
			defaultValue: "<",
			hideCode: "<",
			searchCode: "<",
			hidePrimary: "<",
			onBlur: "&",
			onFocus: "&",
			shouldRequestPrimaryUpdate: "<",
			renderingOptions: "<",
			entityQueryConfiguration: "<",
			hasEffectiveRanges: "<"
		},
		require: {
			reportScope: "?^^reportScope"
		}
	}).name;
